module.exports = __webpack_public_path__ + "img/img_nav_detail-w.eba59086.svg";